import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { routes } from '@platform/core/lib/routes';
import { WorkspaceLink, workspaceType } from '@platform/navigation';
import { initials } from '../../shell/initials';
import { SysNote } from '../system/SysNote';
import { SysTable } from '../system/SysTable';
import { SystemPage } from '../system/SystemPage';
import { WorkspaceMembersCount } from './WorkspaceMembersCount';
import { WorkspaceModulesCount } from './WorkspaceModulesCount';
import { useWorkspaceRows } from './useWorkspaceRows';

const COLUMNS = 'minmax(200px, 2.2fr) 140px 80px 80px 130px 110px';

/**
 * «Робочі простори» (прототип v4 G:L8147–8217, pgAdmWs): простір (плитка ініціалів кольору типу, назва, «Поточний»), тип, учасники, модулі,
 * ваша роль («Не учасник» для чужих) і «Перемкнути» — з каталогу платформи; сервер без каталогу дає лише простори користувача, про що
 * каже примітка.
 */
export function AdminWorkspacesPage() {
  const { t } = useTranslation();
  const label = useLabel();
  const { ws } = useWorkspaceParams();
  const { rows: list, directory } = useWorkspaceRows();
  const rows = list.map((w) => {
    const type = workspaceType(w.type);
    const current = w.id === ws;
    return {
      key: w.id, current,
      cells: [
        <span key="n" className="sp-who">
          <span className="sp-tile" style={{ background: type.tone }}>{initials(w.name)}</span>
          <span className="sp-strong ad-ellipsis">{w.name}</span>
          {current && <span className="sp-badge">{t('sysAdmin.workspaces.current')}</span>}
        </span>,
        label(type.label),
        w.members !== null ? <span key="m" className="sp-mono">{w.members}</span> : <WorkspaceMembersCount key="m" ws={w.id} />,
        w.modules !== null ? <span key="c" className="sp-mono">{w.modules}</span> : <WorkspaceModulesCount key="c" ws={w.id} />,
        <span key="r" className={w.role ? undefined : 'sp-muted'}>{w.role ? t(`roles.${w.role}`, { defaultValue: w.role }) : t('sysAdmin.workspaces.notMember')}</span>,
        <span key="a" className="sp-actions">{w.role && !current && <WorkspaceLink className="sp-btn sp-btn--accent" ws={w.id} to={routes.home()}>{t('sysAdmin.workspaces.switch')}</WorkspaceLink>}</span>,
      ],
    };
  });
  return (
    <SystemPage title={t('sysPages.sections.workspaces')} sub={t('sysAdmin.workspaces.sub')}>
      <SysTable columns={COLUMNS} minWidth={820} rows={rows} label={t('sysPages.sections.workspaces')}
        head={[t('sysAdmin.workspaces.workspace'), t('sysAdmin.workspaces.type'), t('sysAdmin.workspaces.members'), t('sysAdmin.workspaces.modules'), t('sysAdmin.workspaces.yourRole'), '']} />
      {!directory && <SysNote>{t('sysAdmin.workspaces.onlyMine')}</SysNote>}
    </SystemPage>
  );
}
